(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["30-off-full-banner-image-2"]) return;
  try {
    
  $(".full_banner_2 .fancybox")
  .attr('rel', 'gallery')
  .fancybox({
    openEffect  : 'none',
    closeEffect : 'none',
    nextEffect  : 'none',
    prevEffect  : 'none',
    padding     : 0,
    margin      : [20, 60, 20, 60] // Increase left/right margin
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["30-off-text-with-banner-2"]) return;
  try {
    
  $("#home_video_page_50 .video_btn").click(function(){

  var parent = $(this).parent();
  var link = $(".video",parent).attr("data-auto");
  $("img",parent).hide();
  $(".video",parent).show();
  var iframe = $("<div class='video-wrapper'><iframe width='100%' height='315' src='"+link+"'></div>");
  $(".video",parent).html("");
  $(".video",parent).append(iframe);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coffee-mug-giveaway-form-inside"]) return;
  try {
    

  function mailChimpCallback(resp) {
    if (resp.result === "error" ) {
      msg = resp.msg;
      $("#tayst_sample_box .bar-green p").html(msg);
    }
    else{
      window.location.href = '/pages/office-thank-you'; 
    }
  };

  var form = $('#office_coffee_form');
  form.submit(function(e){
    debugger;
    e.preventDefault();
    var action = form.attr("action");
    var url = action.replace('/post?', '/post-json?').concat('&c=?');
    $.ajax({
      url: url,
      data: form.serialize(),
      dataType: "json",        
      async: true,
      success: mailChimpCallback,
      error: function(data) {
        mailChimpCallback(data)
      }
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eighteen-package-introductory_box"]) return;
  try {
    
  function isScrolledIntoView(elem)
  {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemTop <= docViewBottom));
  }
  $(document).ready(function(){
  $(document).on("click",".scroll_down",function(){
  $('html, body').animate({
  scrollTop: $("#product_desc").offset().top
}, 1000);
});

$(window).scroll(function(){
var isElementInView = isScrolledIntoView($('#product_desc'), false);

if (!isElementInView) {
$(".scroll_down").show();
} else {
$(".scroll_down").hide();
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-number-of-cups"] && !window.DesignMode) return;
  try {
    
$( document ).ready(function() {
    $('.cup-details ul li').click(function(){
      $(".active").removeClass("active");
      var $li =$(this).closest('li');
      $li.find("a:first").addClass("active");      
      $(this).addClass("active"); 
    });
$("#home-number-of-cups .get_started").click(function(){
var link = "/products/pods-for-keurig";
window.location.href = link;
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
     var grid_w = $('#home_testimonials .list').width();
    if($(window).width() > 1024 ){
      grid_w = $('#home_testimonials .list').width()/3;
    }else if($(window).width() > 767){
      grid_w = $('#home_testimonials .list').width()/2;
    }
    grid_w = parseInt(grid_w);
    $('#home_testimonials .list').gridalicious(
      {width: grid_w,  
       animate: true,
       gutter : 30,
       animationOptions: {
         queue: true,
         speed: 200,
         duration: 300,
         effect: 'fadeInOnAppear'
       }}
    );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-introductory_box"]) return;
  try {
    
  function isScrolledIntoView(elem)
  {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemTop <= docViewBottom));
  }
  $(document).ready(function(){
  $(document).on("click",".scroll_down",function(){
  $('html, body').animate({
  scrollTop: $("#product_desc").offset().top
}, 1000);
});

$(window).scroll(function(){
var isElementInView = isScrolledIntoView($('#product_desc'), false);

if (!isElementInView) {
$(".scroll_down").show();
} else {
$(".scroll_down").hide();
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["office-coffee-form-banner"]) return;
  try {
    
  $(document).ready(function(){
    //     if($("#requestSample .feedback").length > 0){
    //       $.fancybox($("#requestSample"));
    //     }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["office-coffee-form-inside-klaviyo"]) return;
  try {
    

  function mailChimpCallback(resp) {
    if (resp.result === "error" ) {
      msg = resp.msg;
      $("#tayst_sample_box .bar-green p").html(msg);
    }
    else{
      window.location.href = '/pages/office-thank-you'; 
    }
  };

  var form = $('#office_coffee_form');
  form.submit(function(e){
    debugger;
    e.preventDefault();
    var action = form.attr("action");
    var url = action.replace('/post?', '/post-json?').concat('&c=?');
    $.ajax({
      url: url,
      data: form.serialize(),
      dataType: "json",        
      async: true,
      success: mailChimpCallback,
      error: function(data) {
        mailChimpCallback(data)
      }
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["office-coffee-form-inside"]) return;
  try {
    

  function mailChimpCallback(resp) {
    if (resp.result === "error" ) {
      msg = resp.msg;
      $("#tayst_sample_box .bar-green p").html(msg);
    }
    else{
      window.location.href = '/pages/office-thank-you'; 
    }
  };

  var form = $('#office_coffee_form');
  form.submit(function(e){
    debugger;
    e.preventDefault();
    var action = form.attr("action");
    var url = action.replace('/post?', '/post-json?').concat('&c=?');
    $.ajax({
      url: url,
      data: form.serialize(),
      dataType: "json",        
      async: true,
      success: mailChimpCallback,
      error: function(data) {
        mailChimpCallback(data)
      }
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-one_box"]) return;
  try {
    
  function isScrolledIntoView(elem)
  {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemTop <= docViewBottom));
  }
  $(document).ready(function(){
  $(document).on("click",".scroll_down",function(){
  $('html, body').animate({
  scrollTop: $("#product_desc").offset().top
}, 1000);
});

$(window).scroll(function(){
var isElementInView = isScrolledIntoView($('#product_desc'), false);

if (!isElementInView) {
$(".scroll_down").show();
} else {
$(".scroll_down").hide();
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twelve-package-introductory_box"]) return;
  try {
    
  function isScrolledIntoView(elem)
  {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemTop <= docViewBottom));
  }
  $(document).ready(function(){
  $(document).on("click",".scroll_down",function(){
  $('html, body').animate({
  scrollTop: $("#product_desc").offset().top
}, 1000);
});

$(window).scroll(function(){
var isElementInView = isScrolledIntoView($('#product_desc'), false);

if (!isElementInView) {
$(".scroll_down").show();
} else {
$(".scroll_down").hide();
}
});
});

  } catch(e) { console.error(e); }
})();
})();
